module.exports = __webpack_public_path__ + "8703eec82615e5b6b083b84d7b140ee8.jpg";